// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUi from 'element-ui'
import Vant from 'vant';
import MetaInfo from 'vue-meta-info'
import VueCookies from 'vue-cookies'
import moment from 'moment'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import api from './axios/api'
import fsApi from './feishu/api'
import uploadAliOss from './js/uploadAliOss'
import local from './axios/local'
import common from './js/common'
import Pagination from './components/pagination/pagination'
import Tip from './components/dialog/tip'
import gh_dialog from './components/dialog/gh-dialog' 
import datepicker from './components/datepicker/datepicker' 

import * as echarts from 'echarts'
// import '../static/echarts/world'

import vClipboard from 'vue-clipboard2'
import '@/theme/index.css'
import '@/css/common.css'
// import 'element-ui/lib/theme-chalk/index.css'

import 'swiper/swiper-bundle.css'
import 'vant/lib/index.css';
import animated from 'animate.css'
Vue.use(ElementUi)
Vue.use(Vant)
Vue.use(MetaInfo)
Vue.use(VueAwesomeSwiper)
Vue.use(common)
Vue.use(animated)
Vue.use(vClipboard)
Vue.use(VueCookies)
Vue.use(moment)

Vue.component('Pagination', Pagination)
Vue.component('Tip', Tip)
Vue.component('Gh-Dialog', gh_dialog)
Vue.component('DatePicker', datepicker)

Vue.config.productionTip = false;
Vue.prototype.api = api;
Vue.prototype.fsApi = fsApi;
Vue.prototype.local = local;
Vue.prototype.echarts = echarts;
Vue.prototype.uploadAliOss = uploadAliOss;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js